export const UPLOADING_PLAN = {
  ROOT: '/uploadingPlan',
  APARTMENTS: '/uploadingPlan/apartments',
  ENGINEERING_NETWORKS: '/uploadingPlan/engineering_networks',
};
